export const FORM_KEYS = {
  FORMAT: {
    key: 'format',
    label: '$ Format',
  },
  DEN: {
    key: 'diligenceEarningsNormalization',
    label: 'Diligence Earnings Normalization',
    tip: 'tip',
  },
  CLIENT_EBITDA: {
    key: 'buyerEbitda',
    label: 'EBIT',
  },
  TARGET_EBITDA: {
    key: 'targetEbitda',
    label: '',
  },
  EBIT_LABEL: {
    key: 'ebitLabel',
  },
  TABLE_WRAPPER: {
    key: 'valueDriverItems',
  },
  TYPE: {
    label: 'Type',
    key: 'type',
    // placeholder: 'Please enter the module name',
  },
  SYNERGY: {
    label: 'Synergy',
    key: 'synergy',
  },
  HAS_LINK: {
    label: 'Link URL',
    key: 'hasLinkUrl',
  },
  LinkURL: {
    placeholder: 'Please enter the link here',
    label: 'link URL',
    key: 'linkUrl',
  },
  CATEGORY: {
    label: 'Category',
    key: 'category',
  },
  DES: {
    label: 'Description',
    key: 'description',
  },
  PROBABILITY: {
    label: 'Probability of Success',
    key: 'probabilityOfSuccess',
  },
  TIME_TO_ACHIEVE: {
    label: 'Time to Achieve',
    key: 'timeToAchieve',
  },
  // FINANCIALIMPACT_DOLLAR: {
  //   label: 'Financial Impact',
  //   key: 'financialImpactOfDollarValue',
  //   // placeholder: 'Please enter the link here',
  // },
  // FINANCIALIMPACT_SCALE: {
  //   label: 'Financial Impact',
  //   key: 'financialImpactOfScale',
  //   // placeholder: 'Please enter the link here',
  // },
  // ONE_TIME_COST_SCALE: {
  //   key: 'oneTimeCostToAchieveOfScale',
  //   label: 'One-time Cost to Achieve',
  // },
  // ONE_TIME_COST_DOLLAR: {
  //   key: 'oneTimeCostToAchieveOfDollarValue',
  //   label: 'One-time Cost to Achieve',
  // },
  FINANCIAL_IMPACT: {
    label: 'Financial Impact',
    key: 'financialImpact',
  },
  ONE_TIME_COST: {
    key: 'oneTimeCostToAchieve',
    label: 'One-time Cost to Achieve',
  },
  ORDER: {
    key: 'displayOrder',
  },
  DELETE: {
    key: 'id',
  },

  DRAG: {
    key: 'drag',
  },

  DisplayFigures: {
    key: 'displayFigures',
  },
  displayEbitAndDiligence: {
    key: 'displayEbitAndDiligence',
  },
  RICH_TEXT: {
    key: 'richText',
  },
  RICH_TITLE: {
    key: 'richTitle',
  },
};
